/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-param-reassign */
// Package Imports
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

// Models
import { AuthMetaData, UserSessionData } from '../../models';

// Services
import { CdbHttpClientService } from 'cdb-http-client';
import { AuthorizationService } from '../authorization/authorization.service';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root'
})
export class OeHttpClientService extends CdbHttpClientService {
  constructor(http: HttpClient,
              router: Router,
              private readonly authorizationService: AuthorizationService,
              private readonly sessionService: SessionService) {
    super(http, router);
  }

  getOptions(): any {
    return super.getDefaultOptions();
  }

  get(url: string, options?: any): Observable<any> {
    const user: UserSessionData = this.sessionService.getSessionData(this.sessionService.sessionKey_UserSession);
    const partnerData: AuthMetaData = this.sessionService.getSessionData(this.sessionService.sessionKey_AuthMetaData);

    let partner = '';
    let entityIdForAdminView: string = null;

    if (partnerData) {
      partner = partnerData.partner;
      entityIdForAdminView = partnerData.entityIdForAdminView;
    }
    else {
      partner = '';
    }

    options = this.appendOptionsByPartnerName(options, partner, entityIdForAdminView);

    return from(this.authorizationService.getAuthorizationHeaderValue())
      .pipe(mergeMap(bearerToken => super.get(url, bearerToken, options)));
  }

  post(url: string, data: any, options?: any): Observable<any> {
    const partnerData: AuthMetaData = this.sessionService.getSessionData(this.sessionService.sessionKey_AuthMetaData);

    let partner = '';
    let entityIdForAdminView: string = null;

    if (partnerData) {
      partner = partnerData.partner;
      entityIdForAdminView = partnerData.entityIdForAdminView;
    }
    else {
      partner = '';
    }

    options = this.appendOptionsByPartnerName(options, partner, entityIdForAdminView);

    return from(this.authorizationService.getAuthorizationHeaderValue())
      .pipe(mergeMap(bearerToken => super.post(url, data, bearerToken, options)));
  }

  put(url: string, data: any, options?: any): Observable<any> {
    const user: UserSessionData = this.sessionService.getSessionData(this.sessionService.sessionKey_UserSession);
    const partnerData: AuthMetaData = this.sessionService.getSessionData(this.sessionService.sessionKey_AuthMetaData);


    options = this.appendOptionsByPartnerName(options, partnerData.partner, partnerData.entityIdForAdminView);

    return from(this.authorizationService.getAuthorizationHeaderValue())
      .pipe(mergeMap(bearerToken => super.put(url, data, bearerToken, options)));
  }

  delete(url: string, data?: string, options?: any): Observable<any> {
    const partnerData: AuthMetaData = this.sessionService.getSessionData(this.sessionService.sessionKey_AuthMetaData);

    options = this.appendOptionsByPartnerName(options, partnerData.partner, partnerData.entityIdForAdminView);

    return from(this.authorizationService.getAuthorizationHeaderValue())
      .pipe(mergeMap(bearerToken => super.delete(url, bearerToken, data, options)));
  }

  postForm(url: string, data: any, options?: any): Observable<any> {
    const partnerData: AuthMetaData = this.sessionService.getSessionData(this.sessionService.sessionKey_AuthMetaData);

    options = this.appendOptionsByPartnerName(options, partnerData.partner, partnerData.entityIdForAdminView, true);

    return from(this.authorizationService.getAuthorizationHeaderValue())
      .pipe(mergeMap(bearerToken => super.postForm(url, data, bearerToken, options)));
  }

  private appendOptionsByPartnerName(options: any, partnerName: string, entityIdForAdminView: string = null,
                                     isPostForm: boolean = false): any {
    if (!options) {
      if (!isPostForm) {
        options = super.getDefaultOptions();
      }
      else {
        options = { headers: new HttpHeaders({ 'Cache-Control': 'no-cache', Pragma: 'no-cache' }) };
      }
    }

    if (!options.headers) {
      if (!isPostForm) {
        options.headers = super.getDefaultOptions().headers;
      }
      else {
        options.headers = new HttpHeaders({ 'Cache-Control': 'no-cache', Pragma: 'no-cache' });
      }
    }

    if (!options.headers.has('admin-view') && entityIdForAdminView != null) {
      options.headers = options.headers.append('admin-view', entityIdForAdminView);
    }

    if (!options.headers.has('partner-db-name')) {
      options.headers = options.headers.append('partner-db-name', partnerName);

      return options;
    }
    else {
      return options;
    }
  }
}
